import { isArray } from 'utils';

const findInArrayByKeyValue = (arrayToCheck = [], key, keyValueToFind) => {
  return key && keyValueToFind && isArray(arrayToCheck)
    ? arrayToCheck.find(x => x[key] === keyValueToFind) : null;
};

export default findInArrayByKeyValue;
